export enum PaymentStatus {
  Pending = "Pending",                // Payment is created but not yet processed
  PreAuthorized = "PreAuthorized",    // Funds are held (preauth/hold)
  Captured = "Captured",              // Preauth has been captured (funds moved)
  Voided = "Voided",                  // Preauth has been voided/canceled (hold released)
  Posted = "Posted",                  // Direct charge succeeded (funds moved)
  Failed = "Failed",                  // Payment attempt failed
  Cancelled = "Cancelled",            // Payment was cancelled by user/system
  Partial = "Partial",                // Partial payment succeeded
  Refunded = "Refunded"               // Full payment returned to users card 
}
